import { defineComponent } from '@digitalbranch/app'

import template from './card-content.html'
import css from './card-content.css'

export const uiCardContent = defineComponent({
  name: 'ui-card-content',
  template,
  css,
})
